import React from 'react'

// Types
import { AuthState, User } from '../types'

// Config
import { api as apiConfig } from '../../../config'

// Context
import AuthContext, { initialState } from './AuthContext'

// Utilities
import * as api from '../api'
import { store } from '../../cookies'

export default (
  userState: { [prop: string]: any } = {}
) => (
  WrappedComponent: React.ComponentType
): any => class NavigationContainer extends React.Component {

  state: AuthState = { ...initialState, ...userState } 

  constructor(props: any) {
    super(props)

    this.state.actions = {
      authenticate: this.authenticate,
      login: this.login,
      logout: this.logout,
      signup: this.signup,
      setFetching: this.setFetching,
    }
  }

  authenticate = async () => {
    const user = await api.authenticate()
    if(user) {
      store.set(apiConfig.tokenName, user.authToken, 1209600)
    }
    this.setState({ user, fetching: false })
  }

  login = async (username: string, password: string) => {
    this.setFetching(true)
    
    const user = await api.login(username, password)
    if(user) {
      store.set(apiConfig.tokenName, user.authToken, 1209600)
    }
    this.setState({ user, fetching: false })
  }

  logout = () => {
    api.logout()
    this.setState({ user: null, fetching: false })
    store.set(apiConfig.tokenName, null, -1)
  }

  signup = async (user: User) => {
    this.setFetching(true)
    
    try {
      const signup = await api.signup(user)
      if(user) {
        store.set(apiConfig.tokenName, signup.authToken, 1209600)
      }
      this.setState({ user: signup, fetching: false })
      
      var url = new URL(window.location.href)
      var redirectUrl = url.searchParams.get("redirect_url")
      window.location.href = redirectUrl || '/login/'

    } 
    catch (err) {
      this.setState({ user, fetching: false, signupError: err.message })
    }
  }

  setFetching = (fetching: boolean) => {
    this.setState({ fetching })
  }

  render() {
    return (
      <AuthContext.Provider value={this.state}>
        <WrappedComponent {...this.props} />
      </AuthContext.Provider>
    )
  }

}
